<div class="btn-extra {{ disabled ? 'btn-extra--disabled' : '' }}">
    <ca-spinner *ngIf="isLoading; else showContentSave" [color]="'#FF7344'"></ca-spinner>
    <ng-template #showContentSave>
        <ng-content></ng-content>
    </ng-template>
</div>
